import { render, staticRenderFns } from "./CitiesTable.vue?vue&type=template&id=6d21591d&"
import script from "./CitiesTable.vue?vue&type=script&lang=js&"
export * from "./CitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports